/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { TouchableOpacity, View } from "react-native";

import { skaleBlack, skaleBlue, skaleWebTextGray } from "config/UpduoColors";
import { Text } from "UpduoLibrary";

interface TableTabProps {
  isActive?: boolean;
  onPress?: any;
  label?: string;
}

export default function TableTab({ isActive, onPress, label }: TableTabProps) {
  const tabHighlight = (
    <View
      style={{
        position: "absolute",
        bottom: -10,
        left: 0,
        right: 0,
        height: 3,
        zIndex: 100,
        backgroundColor: skaleBlue,
        borderRadius: 12,
      }}
    />
  );
  return (
    <TouchableOpacity
      style={{
        marginHorizontal: 15,
        marginTop: 15,
        paddingBottom: 15,
        alignItems: "center",
      }}
      onPress={onPress}
    >
      <Text
        style={{
          fontWeight: isActive ? "bold" : "normal",
          color: isActive ? skaleBlack : skaleWebTextGray,
          fontSize: 16,
        }}
      >
        {label}
      </Text>
      {isActive ? tabHighlight : null}
    </TouchableOpacity>
  );
}
